import script from "./CreateService.vue?vue&type=script&setup=true&lang=ts"
export * from "./CreateService.vue?vue&type=script&setup=true&lang=ts"

import "./CreateService.vue?vue&type=style&index=0&id=454839ea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-454839ea"]])

export default __exports__